module.exports = __webpack_public_path__ + "img/toggle-key-icon.a2af22d4.svg";